<script setup>
import { ref, onMounted, watch, defineProps } from 'vue'
import WidgetNumber from '@/components/ui/WidgetNumber.vue'
import api from '@/api'
import { useI18n } from '@/i18n'

const props = defineProps({
  groupId: { type: Number, required: true }
})

const { t } = useI18n()
const loading = ref(false)
const error = ref('')
const kpi = ref(null)

async function load() {
  loading.value = true; error.value = ''
  try {
    const { data } = await api.getGroupSummary(props.groupId)
    kpi.value = data
  } catch (e) {
    console.error(e); error.value = t('hackwatch.groupDetail.kpisError')
  } finally { loading.value = false }
}

onMounted(load)
watch(() => props.groupId, load)
</script>

<template>
  <div class="hw-card">
    <div class="hw-card-header">
      <i class="pi pi-chart-bar hw-card-icon" />
      <span class="hw-card-title">{{ t('hackwatch.groupDetail.legendKpis') }}</span>
    </div>
    <div class="hw-card-body">
      <div class="grid">
        <div v-if="loading" class="col-12 muted">{{ t('hackwatch.groupDetail.kpisLoading') }}</div>
        <div v-else-if="error" class="col-12 error-text">{{ error }}</div>
        <template v-else-if="kpi">
          <div class="col-6 md:col-3">
            <WidgetNumber title="Posts" :value="kpi.posts_count" variant="info" />
          </div>
          <div class="col-6 md:col-3">
            <WidgetNumber title="Profiles" :value="kpi.profiles_count" variant="success" />
          </div>
          <div class="col-6 md:col-3">
            <WidgetNumber title="Locations" :value="kpi.locations_count" variant="default" />
          </div>
          <div class="col-6 md:col-3">
            <WidgetNumber title="TTPs" :value="kpi.ttps_count" variant="primary" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
.error-text { color: var(--p-danger); }
.muted { opacity: .65; }
</style>